import './Reviews.css';

import one from "./1.jpeg";
import two from "./2.jpg";
import three from "./3.jpeg";


import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";

export default function Review() {

  
  useEffect(() => {
    Aos.init();
  }, []);

    return <section id='reviews'>

     <h2 data-aos="fade-up" data-aos-duration="1000">What People Say</h2>

      <div className='cont-rew'>

        <div className='block-rew' data-aos="fade-up"   data-aos-duration="1000">
        <img src={one} alt='one' />
        <p>Great service for $99! Quick and thorough pool cleaning. Very satisfied!</p>
        <h3>Noah Roberts</h3>
        </div>

        <div className='block-rew' data-aos="fade-up"  data-aos-duration="1000">
        <img src={two} alt='two' />
        <p>Professionals at their best! My pool sparkles after their visit. Highly recommend.</p>
        <h3>Lin Zhang</h3>
        </div>

        <div className='block-rew' data-aos="fade-up"  data-aos-duration="1000">
        <img src={three} alt='two' />
        <p>Superb! Clean pool and excellent service. Very happy with the result.</p>
        <h3>Ethan Mitchell</h3>
        </div>

      </div>
      
  </section>
}
